<div class="content-with-filled-button" *ngIf="!incomeNew; else incomeFormNew">
  <h2 class="sub-title" id="generalTitle" [innerHtml]="copyService.copies.income_form.title"></h2>
  <form [formGroup]="formGroup">
    <div class="row" id="incomeFrom">
      <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="funds-description">
          <vcl-form-field label="{{ copyService.copies.income_form.label }}"
            msgErr="{{ copyService.copies.income_form.error }}">
            <input vclInput id="incomeValueInput" voxelMask="currency" [config]="config"
              placeholder="{{ copyService.copies.income_form.input_placeholder }}" [value]="financialInfo.incomes"
              (input)="reactiveInputChangeIncomes($event)" (focus)="reactiveOnFocus()"
              formControlName="incomeValueInput" max="999999999999">
            <span class="info" id="generalSpan">{{ copyService.copies.income_form.span }}</span>
          </vcl-form-field>
        </div>
      </div>
    </div>
  </form>
  <h2 class="sub-title title-margin" id="generalTitle" [innerHtml]="copyService.copies.income_form.title_2"></h2>
  <div class="row" id="incomeFrom">
    <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <div class="funds-description">
        <voxel-form-field id="fundsSelectionLabel" [label]="copyService.copies.income_form.label_2">
          <vcl-select id="fundsSelection" readonly [placeholder]="copyService.copies.income_form.input_placeholder_2"
            (change)="selectOption($event)" required>
            <vcl-select-option *ngFor="let origin of origins" [value]="origin"
              [selected]="incomesSourceSelection.id === origin.id">
              {{ origin.value }}
            </vcl-select-option>
          </vcl-select>
        </voxel-form-field>
      </div>
    </div>
  </div>
</div>
<ng-template class="content-with-filled-button" #incomeFormNew>
  <h2 class="sub-title" id="generalTitle" [innerHtml]="copyService.copies.income_form.title"></h2>
  <div class="incomes-info">
    <em class="icon-itaufonts_informacao"></em>
    <span> {{ copyService.copies.income_form.spanText }}</span>
  </div>
  <form [formGroup]="formGroup">
    <div class="row" id="incomeFrom">
      <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <vcl-form-field label="{{ copyService.copies.income_form.label }}"
          msgErr="{{ copyService.copies.income_form.errorIncomesValue }}">
          <input vclInput id="incomeValueInput" voxelMask="currency" [config]="config"
            placeholder="{{ copyService.copies.income_form.input_placeholder }}" [value]="financialInfo.incomes"
            (input)="reactiveInputChangeIncomes($event)" (focus)="reactiveOnFocus()" formControlName="incomeValueInput"
            max="999999999999">
        </vcl-form-field>
        <!-- <span class="note" *ngIf="product_type === 'livingPlace' && has_second_headline">{{copyService.copies.income_form.note_living}}</span> -->
        <span class="note">{{copyService.copies.income_form.note_living}}</span><br />
        <span class="note">{{copyService.copies.income_form.note_loan}}</span>
        <span class="info-input-value" id="generalSpan">{{ informationText }}</span>
      </div>
    </div>
    <h2 class="sub-title" id="generalTitle" [innerHtml]="copyService.copies.income_form.title_2_new"></h2>
    <div class="row" id="incomeFrom">
      <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <div class="funds-description">
          <voxel-form-field id="fundsSelectionLabel" [label]="copyService.copies.income_form.label_2">
            <vcl-select id="fundsSelection" [placeholder]="copyService.copies.income_form.input_placeholder_2"
              (change)="selectOption($event)" required
              [notFoundTitle]="copyService.copies.income_form.filter_not_found_title"
              [notFoundMessage]="copyService.copies.income_form.filter_not_found_message">
              <vcl-select-option *ngFor="let origin of origins" [value]="origin"
                [selected]="financialInfo.funds === origin.value">
                {{ origin.value }}
              </vcl-select-option>
            </vcl-select>
          </voxel-form-field>
        </div>
      </div>
    </div>
    <h3 class="sub-title" id="generalTitle" [innerHtml]="copyService.copies.income_form.title_3"></h3>
    <voxel-radio-button-group formControlName="otherIncomes">
      <voxel-radio-button *ngFor="let button of radioOptions" id="{{button.id}}" [checked]="button.checked"
        (radioButtonChange)="OnRadioClick($event)" value="{{button.value}}"
        radioName="grupo">{{button.label}}</voxel-radio-button>
    </voxel-radio-button-group>
    <div id="formOtherIncomes" [hidden]="showForm">
      <div class="row" id="incomeFrom">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <div class="funds-description">
            <voxel-form-field msgErr="{{ copyService.copies.income_form.errorMessage }}" id="fundsSelectionLabel"
              [label]="copyService.copies.income_form.label3">
              <vcl-select formControlName="otherSourceIncomes" id="fundsSelection"
                [placeholder]="copyService.copies.income_form.input_placeholder_2" (change)="selectOtherOption($event)"
                required [notFoundTitle]="copyService.copies.residence_abroad_copies.filter_not_found_title"
                [notFoundMessage]="copyService.copies.residence_abroad_copies.filter_not_found_message">
                <vcl-select-option *ngFor="let origin of origins" [value]="origin">
                  {{ origin.value }}
                </vcl-select-option>
              </vcl-select>
            </voxel-form-field>
          </div>
        </div>
      </div>
      <div class="row" id="incomeFrom">
        <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
          <vcl-form-field label="{{ copyService.copies.income_form.label }}"
            msgErr="{{ copyService.copies.income_form.errorIncomesValue }}">
            <input vclInput id="otherIncomeValueInput" voxelMask="currency" [config]="config"
              placeholder="{{ copyService.copies.income_form.input_placeholder }}"
              (input)="reactiveInputChangeOtherIncomes($event)" (focus)="reactiveOnFocus()"
              formControlName="otherIncomesValue" max="999999999999">
          </vcl-form-field>
        </div>
      </div>
    </div>
  </form>
</ng-template>
<app-controls id="incomeFormBtns" [nextLabel]="copyService.copies.income_form.next_button_text"
  [nextDisabled]="!formGroup.valid" (next)="resumeApp()"></app-controls>